import React, { memo } from "react";
import "./HeaderNavigationBar.scss";
import HeaderNavigationItem from "./HeaderNavigationItem/HeaderNavigationItem";
import useHeaderNavigationBar, { Paths } from "./useHeaderNavigationBar";

import { useSelector } from "react-redux";
import {
  isEmployeeDashboardPermission,
  isViewAccountsListPermission,
} from "@store/userData/selectors";

const HeaderNavigationBar = () => {
  const { currentTab } = useHeaderNavigationBar();
  const isAdmin = useSelector(isEmployeeDashboardPermission);
  const isAccountList = useSelector(isViewAccountsListPermission);

  const menuItems = [
    {
      title: "Home",
      path: Paths.HOME,
      isShown: isAdmin,
    },
    {
      title: "Sessions",
      path: Paths.SESSION,
      isShown: true,
    },
    {
      title: "Accounts",
      path: Paths.ACCOUNTS,
      isShown: isAccountList,
    },
    {
      title: "History",
      path: Paths.HISTORY,
      isShown: true,
    },
  ];

  return (
    <nav className="sidebar-menu__wrapper">
      {menuItems.map((item, key) => {
        return item.isShown ? (
          <HeaderNavigationItem
            key={key}
            path={item.path}
            title={item.title}
            currentTab={currentTab}
          />
        ) : null;
      })}
    </nav>
  );
};

export default memo(HeaderNavigationBar);
